import { EmployeeRolesEnum, EmpPrefixEnum, IndiaStatesEnum, TransportEnum } from '@gtpl/shared-models/common-models';
import { ApiProperty } from '@nestjs/swagger';
import { Column, Entity, OneToMany, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EmployeeEducationDetails } from './employee-education-details.entity';
import { EmployeeExperienceDetails } from './employee-experience-details.entity';
import { EmployeeFamilyDetails } from './employee-family-details.entity';
import { EmployeeIdProofDetails } from './employee-id-proof-details.entity';

@Entity('employee_details')
export class EmployeeDetails {

  @PrimaryGeneratedColumn("increment", { name: 'employee_id' })
  employeeId: number;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "employee_type"
  })
  employeeType: string;

  @Column("varchar", {
    nullable: true,
    length: 12,
    name: "employee_code"
  })
  // @Index({unique:true})
  employeeCode: string;

  @Column("varchar", {
    length: 50,
    name: "employee_name"
  })
  employeeName: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "emp_last_name"
  })
  employeeLastName: string;

  @Column("enum", {
    name: "prefix",
    enum: EmpPrefixEnum
  })
  prefix: EmpPrefixEnum;

  @Column("varchar", {
    nullable: true,
    name: "team_code"
  })
  teamCode: string;

  @Column("datetime", {
    nullable: true,
    name: 'date_of_birth',
  })
  dateOfBirth: Date;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "gender"
  })
  gender: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "maritual_status"
  })
  maritualStatus: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "mobile_no"
  })
  mobileNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "alt_mobile_no"
  })
  altMobileNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "email_id"
  })
  emailID: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "blood_group"
  })
  bloodGroup: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "nationality"
  })
  nationality: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "department_id"
  })
  departmentId: string;

  // @Column("varchar", {
  //   nullable: true,
  //   length: 20,
  //   name: "dept_id"
  // })
  // deptId: number;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "priority_one"
  })
  priorityOne: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "priority_type"
  })
  priorityType: string;

  @Column({
    type: 'enum',
    // length:5,
    nullable: true,
    enum: EmployeeRolesEnum,
    default: EmployeeRolesEnum.ADMIN,
    name: "employee_role"
  })
  employeeRole: EmployeeRolesEnum;

  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;

  @Column("varchar", {
    nullable: true,
    length: 300,
    name: "current_address"
  })
  currentAddress: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "permanent_address"
  })
  permanentAddress: string;

  @Column("varchar", {
    name: "state",
  })
  state: string;

  @Column("varchar", {
    name: "pin_code",
  })
  pinCode: string;

  @Column("varchar", {
    name: "permanent_state",
  })
  permanentState: string;

  @Column("varchar", {
    name: "permanent_pin_code",
  })
  permanentPinCode: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "qualification"
  })
  qualification: string;

  @Column("int", {
    nullable: true,
    name: "years_of_exp"
  })
  yearsOfExperience: Number;

  @Column("varchar", {
    nullable: true,
    length: 30,
    name: "company_email"
  })
  companyEmail: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "employee_mode"
  })
  employeeMode: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "employee_status"
  })
  employeeStatus: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "contractor_name"
  })
  contractorName: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "shift_group"
  })
  shiftGroup: string;

  @Column("datetime", {
    nullable: true,

    name: "date_of_join"
  })
  dateOfJoin: Date;

  @Column("datetime", {
    nullable: true,

    name: "date_of_leave"
  })
  dateOfleave: Date;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "workstation_number"
  })
  workstationNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "health_card_number"
  })
  healthCardNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "uan_number"
  })
  uanNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "salary"
  })
  salary: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "bank_account_number"
  })
  bankAccountNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "ifsc_code"
  })
  ifscCode: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "designation"
  })
  designation: string;

  @Column("datetime", {
    nullable: true,
    name: "date_of_entry"
  })
  dateOfEntry: Date;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "emergency_contact_number"
  })
  emergencyContactNo: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "emergency_contact_name"
  })
  emergencyContactName: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "is_probationary_completed"
  })
  isProbPeriodCompleted: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "transportation"
  })
  transportation: string;

  @Column("varchar", {
    nullable: true,
    length: 25,
    name: "accommodation"
  })
  accommodation: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "is_audit_completed"
  })
  isAuditCompleted: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "skill_set"
  })
  skillSet: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "pickup_point"
  })
  pickUpPoint: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "route_number"
  })
  routeNumber: string;

  @Column("blob", {
    nullable: true,
    name: "image"
  })
  image: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "pan_number"
  })
  panNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "esi_number"
  })
  esiNumber: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "reporting_manager"
  })
  reportingManager: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "bank_name"
  })
  bankName: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "emp_category"
  })
  employeeCategory: string;

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "wage_type"
  })
  wageType: string;

  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  // @Column("varchar",{
  //   nullable: true,
  //   length:20,
  //   name:"name"
  //   })
  //   Fname:string;  

  @Column("varchar", {
    nullable: true,
    length: 20,
    name: "aadhaar_number"
  })
  aadhaarNumber: string;

  @Column("varchar", {
    name: "ghi_no"
  })
  ghiNo: string;

  @Column("varchar", {
    name: "gpa_no"
  })
  gpaNo: string;

  // @Column("varchar",{
  //   nullable: true,
  //   length:20,
  //   name:"mobile_phone"
  //   })
  //   mobilePhone:number;

  //   @Column("varchar",{
  //     nullable: true,
  //     length:20,
  //     name:"address"
  //     })
  //     address:string;
  // @OneToMany(type => Attendance, attendance => attendance.empInfo,{cascade: true})
  // @JoinColumn({ name: 'id' })
  // attendanceInfo: [Attendance];
  // @OneToMany(type=>Attendance, attendance=>attendance.empInfo,{cascade: true})
  // attendanceInfo:Attendance[];
  // @OneToMany(type=>ProjectMapping, projectMapping=>projectMapping.empId,{cascade: true})
  // projectMappingInfo:ProjectMapping[];
  // @OneToOne(() => CostCenters, costCenters => costCenters.costCenterId) 
  // specify inverse side as a second parameter
  // costCenters: CostCenters;

  // @OneToOne(() => Projects, projects => projects.projectId) 
  // specify inverse side as a second parameter
  // projects: Projects;
  // @OneToOne(() => Designations, designations => designations.designationId) 
  // specify inverse side as a second parameter
  // designations: Designations;

  @ApiProperty({ type: [EmployeeFamilyDetails] })
  @OneToMany(type => EmployeeFamilyDetails, empInfo => empInfo.employeeDetails, { cascade: true })
  familyDetails: EmployeeFamilyDetails[];

  @ApiProperty({ type: [EmployeeEducationDetails] })
  @OneToMany(type => EmployeeEducationDetails, empInfo => empInfo.employeeDetails, { cascade: true })
  educationDetails: EmployeeEducationDetails[];

  @ApiProperty({ type: [EmployeeIdProofDetails] })
  @OneToMany(type => EmployeeIdProofDetails, empInfo => empInfo.employeeDetails, { cascade: true })
  idProofDetails: EmployeeIdProofDetails[];

  @ApiProperty({ type: [EmployeeExperienceDetails] })
  @OneToMany(type => EmployeeExperienceDetails, empInfo => empInfo.employeeDetails, { cascade: true })
  experienceDetails: EmployeeExperienceDetails[];

  @Column("boolean", {
    default: true,
    name: "is_available"
  })
  isAvailable: boolean;

  @Column("boolean", {
    default: false,
    name: "is_authorised"
  })
  isAuthorised: boolean;
}
